import React from 'react';
import wideBanner from '../../../images/google-ad-wide.jpg';

const WideBanner = () => {
    return (
       <div>
         <div className='flex justify-center mb-6'>
            <img src={wideBanner} alt="" />
        </div>
       </div>
    );
};

export default WideBanner;